<template>
  <div class="record-detail">
    <fixed-header :left="true" title="订单详情" />
    <div class="details-info">
      <div class="details-item">
        <div class="order-id bottom">
          <div class="order-number" v-if="info.courierOrderNo">
            运单号：<span
              >{{ info.courierOrderNo }}（{{ courierCompany }}）</span
            >
          </div>
          <div class="send-info" v-if="!info.courierOrderNo">
            工作人员将在7个工作日内发货
          </div>
          <div
            class="copy-btn"
            v-if="info.courierOrderNo"
            @click="copyText(info.courierOrderNo)"
          >
            复制
          </div>
        </div>
        <div class="order-address">
          <van-icon name="location-o" />
          <div class="address-info">
            <div class="person">
              {{ info.consigneeName }} {{ info.mobileDes || info.mobile }}
            </div>
            <div class="address-detail">
              {{ info.detailAddressComplete }}
            </div>
          </div>
        </div>
      </div>
      <div class="details-item">
        <div class="prod-goods-info" v-if="info.goodsResVos">
          <img
            class="prod-img"
            :src="info.goodsResVos[0].goodsImageUrl"
            alt=""
          />
          <div class="prod-title">{{ info.goodsResVos[0].goodsName }}</div>
        </div>
      </div>
      <div class="details-item">
        <div class="order-id">
          <div class="order-number">
            订单编号：<span>{{ info.id }}</span>
          </div>
          <div v-if="info.id" class="copy-btn" @click="copyText(info.id)">
            复制
          </div>
        </div>
        <div class="order-id">
          <div class="order-number">
            领取时间：<span>{{ info.createTimestamp }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Icon, Toast } from "vant";
import { receiveDetais } from "../../api";
import VueClipboard from "vue-clipboard2";
import FixedHeader from "../../components/FixedHeader";

Vue.use(Icon).use(Toast).use(VueClipboard);

const company = {
  EMS: "邮政特快专递",
  STO_EX: "申通快递",
  ZTO_EX: "中通快递",
  YTO_EX: "圆通速递",
  YUN_DA_EX: "韵达速递",
  TT_EX: "天天快递",
  BEST_EX: "百世快递",
  SF_EX: "顺丰快递",
  ZJS_EX: "宅急送",
  DEPPON_EX: "德邦快递",
};
export default {
  name: "RecordDetails",
  components: { FixedHeader },
  computed: {
    courierCompany() {
      return company[this.info.courierCompany] || this.info.courierCompany;
    },
  },
  data() {
    return {
      info: {},
    };
  },
  mounted() {
    this.getData(this.$route.query.id);
  },
  methods: {
    getData(id) {
      receiveDetais({ id }).then((res) => {
        if (res.code === 200) {
          this.info = res.data;
        }
      });
    },
    copyText(str) {
      this.$copyText(str).then(() => {
        this.$toast("已复制");
      });
    },
  },
};
</script>

<style lang="less">
@import "../../assets/style/variable";

.record-detail {
  .details-info {
    min-height: 700px;
    background-color: #f3f3f3;
    padding-top: 20 / @baseSize;

    .details-item {
      margin: 0 20 / @baseSize 20 / @baseSize 20 / @baseSize;
      padding: 20 / @baseSize;
      background-color: #ffffff;
      border-radius: 10 / @baseSize;

      .order-id {
        display: flex;
        justify-content: space-between;
        line-height: 44 / @baseSize;

        &.bottom {
          padding-bottom: 12 / @baseSize;
          border-bottom: 1px solid #efefef;
        }

        .order-number {
          color: #999999;
          font-size: 24 / @baseSize;

          span {
            padding-left: 8 / @baseSize;
            color: #333333;
          }
        }

        .send-info {
          font-size: 24 / @baseSize;
          color: #1976f9;
        }

        .copy-btn {
          display: block;
          font-size: 20 / @baseSize;
          color: #cccccc;
          height: 34 / @baseSize;
          line-height: 34 / @baseSize;
          text-align: center;
          width: 70 / @baseSize;
          border-radius: 30 / @baseSize;
          border: 1px solid #cccccc;
        }
      }

      .order-address {
        position: relative;
        min-height: 40 / @baseSize;

        .van-icon {
          font-size: 32 / @baseSize;
          color: #cccccc;
          position: absolute;
          left: 0;
          top: 4 / @baseSize;
        }

        .address-info {
          margin-left: 40 / @baseSize;
          font-size: 24 / @baseSize;

          .person {
            margin-top: 20 / @baseSize;
          }

          .address-detail {
            margin-top: 12 / @baseSize;
          }
        }
      }

      .prod-goods-info {
        display: flex;
        min-height: 140 / @baseSize;

        .prod-img {
          display: block;
          width: 140 / @baseSize;
          height: 140 / @baseSize;
          margin-right: 20 / @baseSize;
          background-color: #f3f3f3;
        }

        .prod-title {
          font-size: 26 / @baseSize;
        }
      }
    }
  }
}
</style>
